import { format as formatTz, utcToZonedTime } from "date-fns-tz";

export function formatInTimeZone(fmt: string, tz: string, date?: string | number | Date) {
  if (date) return formatTz(utcToZonedTime(date, tz), fmt, { timeZone: tz });

  return undefined;
}
